<template>
  <div class="FormDate" @keyup.capture="updateValue">
    <input
      v-if="showMonth"
      ref="month"
      v-model="month"
      class="FormDate__input FormDate__input month"
      type="number"
      placeholder="mm"
      :disabled="disabled"
      @input="updateMonth"
      @blur="checkMonth">
    <span v-if="showDay && showMonth" class="FormDate__divider">/</span>
    <input
      v-if="showDay"
      ref="day"
      v-model="day"
      class="FormDate__input FormDate__input day"
      type="number"
      placeholder="dd"
      :disabled="disabled"
      @input="updateDay"
      @blur="checkDay">
    <span v-if="showYear && (showDay || showMonth)" class="FormDate__divider">/</span>
    <input
      v-if="showYear"
      ref="year"
      v-model="year"
      class="FormDate__input FormDate__input year"
      type="number"
      placeholder="yyyy"
      :disabled="disabled"
      @blur="checkYear">
      <transition name="fade">
          <div class="message" v-if="message">{{ message }}</div>
      </transition>
  </div>
</template>

<script>
export default {
    name: 'FormDate',
    props: {
        value: {
            type: [Number, String],
            required: false,
        },
        showDay: {
            type: Boolean,
            default: true,
        },
        showMonth: {
            type: Boolean,
            default: true,
        },
        showYear: {
            type: Boolean,
            default: true,
        },
        allowFuture: {
            type: Boolean,
            default: false,
        },
        allowPast: {
            type: Boolean,
            default: true,
        },
        warnPast: {
            type: Boolean,
            default: false,
        },
        minYear: {
            type: Number,
            default: 1900,
        },
        disabled: {
            type: [Boolean, String],
            default: false
        }
    },
    data() {
        return {
            day: '',
            month: '',
            year: '',
            localValue: '',
            validDay: false,
            validMonth: false,
            validYear: false,
            message: ''
        }
    },
    created() {
        if (this.value) {
            this.localValue = this.value
        }
        this.day = `${this.localValue ? ('0' + new Date(this.localValue.replace(/-/g, '\/')).getDate()).slice(-2) : ''}`
        this.month = `${this.localValue ? ('0' + (new Date(this.localValue.replace(/-/g, '\/')).getMonth() + 1)).slice(-2) : ''}`
        this.year = `${this.localValue ? new Date(this.localValue.replace(/-/g, '\/')).getFullYear() : ''}`
    },
    watch: {
        localValue(value) {
            this.day = `${this.localValue ? ('0' + new Date(this.localValue.replace(/-/g, '\/')).getDate()).slice(-2) : ''}`
            this.month = `${this.localValue ? ('0' + (new Date(this.localValue.replace(/-/g, '\/')).getMonth() + 1)).slice(-2) : ''}`
            this.year = `${this.localValue ? new Date(this.localValue.replace(/-/g, '\/')).getFullYear() : ''}`
            this.updateValue()
        }
    },
    methods: {
        updateMonth() {
            if (!this.month.length) return
            if (this.month == '0') return
            if (this.month.length < 2) return
            if (parseInt(this.month) < 1 || parseInt(this.month) > 12) {
                this.month = ''
                return
            }
            if (this.showDay) this.$refs.day.select()
        },
        checkMonth() {
            if (parseInt(this.month) > 0) {
                this.month = parseInt(this.month).toString().padStart(2, 0)
            } else {
               this.month = ''
            }
        },
        updateDay() {
            if (!this.day.length) return
            if (this.day == '0') return
            if (this.day.length < 2) return
            if (parseInt(this.day) < 1 || parseInt(this.day) > 31) {
                this.day = ''
                return
            }
            if (this.day > 0) {
                this.day = parseInt(this.day).toString().padStart(2, 0)
            }
            if (this.showYear) this.$refs.year.select()
        },
        checkDay() {
            if (parseInt(this.day) > 0) {
                this.day = this.day.padStart(2, 0)
            } else {
                this.day = ''
            }
        },
        checkYear() {
            if (parseInt(this.year) > 0) {
                if (this.year.length != 4) {
                    this.message = 'Year must be four digits'
                    setTimeout(() => {
                        this.message = ''
                        this.year = ''
                        this.$refs.year.select()
                    }, 1000)
                    return
                }
                if (parseInt(this.year) < this.minYear) {
                    this.message = 'Year must be > 1900'
                    setTimeout(() => {
                        this.message = ''
                        this.year = ''
                        this.$refs.year.select()
                    }, 1000)
                    return
                }
            } else {
                this.year = ''
            }
        },
        updateValue() {
            this.validMonth = this.month.length == 2 && parseInt(this.month) > 0 && parseInt(this.month) < 13
            this.validDay = this.day.length == 2 && parseInt(this.day) > 0 && parseInt(this.day) < 32
            this.validYear = this.year.length == 4 && parseInt(this.year) > this.minYear
            if (this.validDay && this.validMonth && this.validYear) {
                const timestamp = Date.parse(`${this.year}-${this.month}-${this.day}`);
                if (Number.isNaN(timestamp)) return;
                if (!this.allowFuture) {
                    let now = Date.now()
                    if (timestamp > now) {
                        this.message = 'Future date not allowed'
                        setTimeout(() => {
                            this.message = ''
                            this.year = ''
                            this.month = ''
                            this.day = ''
                            this.$refs.month.select()
                        }, 1000)
                        return
                    }
                }
                if (!this.allowPast || this.warnPast) {
                    let now = Date.now()
                    if (timestamp < now) {
                        if (this.warnPast) {
                            this.message = 'Past date warning'
                            setTimeout(() => {
                                this.message = ''
                            }, 2000)
                        } else {
                            this.message = 'Past date not allowed'
                            setTimeout(() => {
                                this.message = ''
                                this.year = ''
                                this.month = ''
                                this.day = ''
                                this.$refs.month.select()
                            }, 1000)
                        }
                        return
                    }
                }
                var date = new Date(timestamp);
                if (date == 'Invalid Date') {
                    this.message = 'Invalid date'
                    setTimeout(() => {
                        this.$refs.month.select()
                        this.message = ''
                        this.year = ''
                        this.month = ''
                        this.day = ''
                    }, 1000)
                    return
                }
                let month = date.getMonth() + 1
                let day = date.getDate() + 1
                let year = date.getFullYear()
                var formattedTime = this.year + '-' + this.month + '-' + this.day;
                this.$emit('input', formattedTime);
            } else {
                this.$emit('input', '');
            }
        }
    }
}
</script>

<style lang="scss">
.FormDate {
    $spacing: 0.75em;
    display: inline-flex;
    position: relative;
    overflow: hidden;
    border: 1px solid #D1D1D1;
    border-radius: 3px;
    max-height: 2.5em;
    max-width: 13em;
    margin: 0 0 0.5em 0;
    &__input {
        padding: $spacing;
        border: none !important;
        margin-bottom: 0 !important;
        text-align: center;
        -moz-appearance: textfield;
        &::-webkit-inner-spin-button {
            display: none;
        }
        &:first-child {
            padding-left: $spacing;
        }
        &:last-child {
            padding-right: $spacing;
        }
        &:focus {
            outline: none;
        }
    }
    &__divider {
        padding: $spacing 0;
        pointer-events: none;
    }
    .day,
    .month {
        width: 30%;
    }
    .year {
        width: 40%;
    }
    .message {
        position: absolute;
        top: -50%; left: 0;
        width: 100%; height: 100%;
        background-color: rgba(255,255,255,.8);
        text-align: center;
        padding: 1em;
        color: red;
    }
}
.error {
    .FormDate {
        &__input {
            border: 1px solid red;
        }
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
}
</style>
